import METADATA from "./ModuleEntity.metadata.js";
import { BaseEntity } from "clavis-nxt-components-custdevtm";

class ModuleEntity extends BaseEntity {
  constructor(code, createdBy, createdTs, modifiedBy, modifiedTs) {
    super();
    this.code = code;
    this.createdBy = createdBy;
    this.createdTs = createdTs;
    this.modifiedBy = modifiedBy;
    this.modifiedTs = modifiedTs;
  }
}

METADATA.connect(ModuleEntity);

export { ModuleEntity };
